module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "cd-transition-layer",
    class: {
      visible: _vm.isVisible
    }
  }), _c('div', {
    staticClass: "bgblackintro"
  }), _c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "animatedgradient"
  }), _c('div', {
    staticClass: "film"
  }, [_c('div', {
    staticClass: "logosection"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("@/assets/The_Film_Button.png"),
      "width": "200px"
    }
  }), _c('div', {
    staticClass: "introsection"
  }, [_vm._v("Find out more about Dreaming of a Jewish Christmas, see the trailer, watch interview excerpts and read about the many people featured both on and off screen.")]), _c('hr', {
    staticClass: "lignemenu mt4"
  })]), _c('div', {
    staticClass: "contentsection ttu"
  }, [_c('div', {
    staticClass: "menucontent"
  }, [_c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "film/about"
    }
  }, [_vm._v("About the Film")])], 1), _c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "film/interviews"
    }
  }, [_vm._v("Interviews")])], 1), _c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "/film/about_team"
    }
  }, [_vm._v("About the Team")])], 1), _c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "film/credits"
    }
  }, [_vm._v("Credits")])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-142e3212","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Film.vue
// module id = 1277
// module chunks = 1